import * as React from "react";
import { SVGProps } from "react";

const Snowswap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 24 24"
    {...props}
  >
    <style>{".st1{fill:#fff}"}</style>
    <linearGradient
      id="SVGID_1_"
      x1={36.833}
      x2={10.871}
      y1={1001.366}
      y2={998.602}
      gradientTransform="matrix(1 0 0 -1 -12 1012)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1adbc5" />
      <stop offset={1} stopColor="#04d3dd" />
    </linearGradient>
    <path
      fill="url(#SVGID_1_)"
      fillRule="evenodd"
      d="M12 24c6.6 0 12-5.4 12-12S18.6 0 12 0 0 5.4 0 12s5.4 12 12 12z"
      clipRule="evenodd"
    />
    <path
      d="m19.2 16.1-1.4-.8 1.1-.3c.3-.1.5-.4.4-.7s-.4-.5-.6-.4l-1.2.3c-.6.2-1.2.1-1.7-.2-.5-.3-.8-.8-.8-1.4v-.2c0-.6.3-1.1.8-1.4.5-.3 1.1-.4 1.7-.2 1.4.4 1.3.4 1.4.4.2 0 .4-.2.5-.4.1-.3-.1-.6-.4-.7l-1.1-.3 1.3-.8c.3-.1.3-.5.2-.7-.1-.3-.5-.3-.7-.2l-1.4.8.3-1.1c.1-.3-.1-.6-.4-.7-.3-.1-.6.1-.6.4l-.3 1.3c-.1.6-.5 1-1 1.3-.5.3-1.1.3-1.6 0l-.1-.1c-.5-.3-.8-.8-.8-1.4 0-.6.2-1.2.7-1.6l.9-.9c.2-.2.2-.5 0-.8-.2-.2-.5-.2-.7 0l-.8.8V4.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.7l-.8-.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .8l.5.8c.4.4.7 1 .7 1.6 0 .6-.3 1.1-.8 1.4l-.1.1c-.5.3-1.1.3-1.6 0s-.9-.8-1-1.3l-.5-1.3c-.1-.3-.4-.5-.7-.4-.2.1-.4.4-.3.7l.3 1.1-1.4-.8c-.3-.2-.6-.1-.8.2-.1.2 0 .6.2.7l1.4.8-1.1.3c-.3.1-.5.4-.4.7.1.2.3.4.5.4.1 0 0 0 1.4-.4.6-.2 1.2-.1 1.7.2.5.3.8.8.8 1.4v.2c0 .6-.3 1.1-.8 1.4-.5.3-1.1.4-1.7.2L5.5 14c-.3-.1-.6.1-.6.4-.1.3.1.6.4.7l1.1.3-1.4.8c-.5.3-.3 1 .3 1 .2 0 .1 0 1.7-.9l-.3 1.1c-.1.3.1.6.4.7.3.1.6-.1.6-.4l.3-1.3c.1-.6.5-1 1-1.3.5-.3 1.1-.3 1.6 0l.1.1c.5.3.8.8.8 1.4 0 .6-.2 1.2-.7 1.6l-.8.8c-.2.2-.2.5 0 .8.2.2.5.2.7 0l.8-.8v1.7c0 .3.2.5.5.5s.5-.2.5-.5V19l.8.8c.1.1.2.2.4.2.5 0 .7-.6.4-.9l-.9-.9c-.4-.4-.7-1-.7-1.6 0-.6.3-1.1.8-1.4l.1-.1c.5-.3 1.1-.3 1.6 0s.9.8 1 1.3l.3 1.3c.1.2.3.4.5.4.3 0 .6-.3.5-.7l-.3-1.1 1.4.8c.3.1.6.1.7-.2.4-.3.4-.6.1-.8zm-5.4-3.5c0 .6-.3 1.2-.9 1.5-.6.3-1.2.3-1.8 0-.5-.3-.9-.9-.9-1.5s.3-1.2.9-1.5c.6-.3 1.2-.3 1.8 0 .6.2.9.8.9 1.5z"
      className="st1"
    />
    <linearGradient
      id="SVGID_2_"
      x1={36.833}
      x2={10.871}
      y1={1001.366}
      y2={998.602}
      gradientTransform="matrix(1 0 0 -1 -12 1012)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#1adbc5" />
      <stop offset={1} stopColor="#04d3dd" />
    </linearGradient>
    <path
      fill="url(#SVGID_2_)"
      fillRule="evenodd"
      d="M12 24c6.6 0 12-5.4 12-12S18.6 0 12 0 0 5.4 0 12s5.4 12 12 12z"
      clipRule="evenodd"
    />
    <path
      d="m19.2 16.1-1.4-.8 1.1-.3c.3-.1.5-.4.4-.7s-.4-.5-.6-.4l-1.2.3c-.6.2-1.2.1-1.7-.2-.5-.3-.8-.8-.8-1.4v-.2c0-.6.3-1.1.8-1.4.5-.3 1.1-.4 1.7-.2 1.4.4 1.3.4 1.4.4.2 0 .4-.2.5-.4.1-.3-.1-.6-.4-.7l-1.1-.3 1.3-.8c.3-.1.3-.5.2-.7-.1-.3-.5-.3-.7-.2l-1.4.8.3-1.1c.1-.3-.1-.6-.4-.7-.3-.1-.6.1-.6.4l-.3 1.3c-.1.6-.5 1-1 1.3-.5.3-1.1.3-1.6 0l-.1-.1c-.5-.3-.8-.8-.8-1.4 0-.6.2-1.2.7-1.6l.9-.9c.2-.2.2-.5 0-.8-.2-.2-.5-.2-.7 0l-.8.8V4.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5v1.7l-.8-.8c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .8l.5.8c.4.4.7 1 .7 1.6 0 .6-.3 1.1-.8 1.4l-.1.1c-.5.3-1.1.3-1.6 0s-.9-.8-1-1.3l-.5-1.3c-.1-.3-.4-.5-.7-.4-.2.1-.4.4-.3.7l.3 1.1-1.4-.8c-.3-.2-.6-.1-.8.2-.1.2 0 .6.2.7l1.4.8-1.1.3c-.3.1-.5.4-.4.7.1.2.3.4.5.4.1 0 0 0 1.4-.4.6-.2 1.2-.1 1.7.2.5.3.8.8.8 1.4v.2c0 .6-.3 1.1-.8 1.4-.5.3-1.1.4-1.7.2L5.5 14c-.3-.1-.6.1-.6.4-.1.3.1.6.4.7l1.1.3-1.4.8c-.5.3-.3 1 .3 1 .2 0 .1 0 1.7-.9l-.3 1.1c-.1.3.1.6.4.7.3.1.6-.1.6-.4l.3-1.3c.1-.6.5-1 1-1.3.5-.3 1.1-.3 1.6 0l.1.1c.5.3.8.8.8 1.4 0 .6-.2 1.2-.7 1.6l-.8.8c-.2.2-.2.5 0 .8.2.2.5.2.7 0l.8-.8v1.7c0 .3.2.5.5.5s.5-.2.5-.5V19l.8.8c.1.1.2.2.4.2.5 0 .7-.6.4-.9l-.9-.9c-.4-.4-.7-1-.7-1.6 0-.6.3-1.1.8-1.4l.1-.1c.5-.3 1.1-.3 1.6 0s.9.8 1 1.3l.3 1.3c.1.2.3.4.5.4.3 0 .6-.3.5-.7l-.3-1.1 1.4.8c.3.1.6.1.7-.2.4-.3.4-.6.1-.8zm-5.4-3.5c0 .6-.3 1.2-.9 1.5-.6.3-1.2.3-1.8 0-.5-.3-.9-.9-.9-1.5s.3-1.2.9-1.5c.6-.3 1.2-.3 1.8 0 .6.2.9.8.9 1.5z"
      className="st1"
    />
  </svg>
);

export default Snowswap;
